import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AlertController } from '@ionic/angular';
import { select, Store } from '@ngrx/store';

import { Observable } from 'rxjs';

import * as fromMonetizationActions from '../../../../store/actions/monetization.actions';
import * as fromMonetizationSelectors from '../../../../store/selectors/monetization.selectors';
import { StripeSubscriptionModel } from '../../../../typings/monetization';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-store-subscriptions',
  standalone: false,
  templateUrl: './subscriptions.page.html'
})
export class SubscriptionsPageComponent {
  private activatedRoute = inject(ActivatedRoute);
  private alertController = inject(AlertController);
  private store = inject(Store);

  defaultBackHref: string | undefined;
  webSubscriptions$: Observable<StripeSubscriptionModel[]>;

  constructor() {
    this.defaultBackHref = this.activatedRoute.snapshot.data['defaultBackHref'];
    this.webSubscriptions$ = this.store.pipe(select(fromMonetizationSelectors.selectWebSubscriptionsList));
  }

  webSubscriptionsListTrackBy(_index: number, item: StripeSubscriptionModel) {
    return item.id;
  }

  ionViewDidEnter() {
    this.store.dispatch(fromMonetizationActions.loadSubscriptions());
  }

  async cancelSubscription(subscription: StripeSubscriptionModel) {
    const alert = await this.alertController.create({
      buttons: [
        {
          role: 'cancel',
          text: 'Return'
        },
        {
          role: 'destructive',
          text: 'Confirm'
        }
      ],
      header: 'Cancel Subscription',
      message: `Are you sure ? You are about to cancel the "${subscription.items[0].product.name}" subscription.`
    });

    await alert.present();

    const { role } = await alert.onDidDismiss();
    if (role === 'destructive') {
      this.store.dispatch(fromMonetizationActions.cancelSubscription({ payload: { id: subscription.id } }));
    }
  }
}
